import { useState, useEffect } from "react";
import MaleOutlinedIcon from "@mui/icons-material/MaleOutlined";
import FemaleOutlinedIcon from "@mui/icons-material/FemaleOutlined";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import SentimentNeutralOutlinedIcon from "@mui/icons-material/SentimentNeutralOutlined";

export const useAssistance = () => {
  // Retrieve the stored value from sessionStorage, or default to 'neutral'
  const storedMode = sessionStorage.getItem("assistanceMode");
  const initialMode = storedMode ? storedMode : "neutral"; // Default to 'neutral' if no value in sessionStorage

  const [assistanceMode, setAssistanceMode] = useState(initialMode);

  type AssistanceOption = {
    type: "male" | "female" | "moodeng" | "neutral";
    icon: JSX.Element;
    title: string;
  };

  const assistanceOptions: AssistanceOption[] = [
    {
      type: "male",
      icon: <MaleOutlinedIcon sx={{ fontSize: 14 }} />,
      title: "บอทผู้ชาย",
    },
    {
      type: "female",
      icon: <FemaleOutlinedIcon sx={{ fontSize: 14 }} />,
      title: "บอทผู้หญิง",
    },
    {
      type: "moodeng",
      icon: <SavingsOutlinedIcon sx={{ fontSize: 14 }} />,
      title: "บอทหมูเด้ง",
    },
    {
      type: "neutral",
      icon: <SentimentNeutralOutlinedIcon sx={{ fontSize: 14 }} />,
      title: "บอทเป็นกลาง",
    },
  ];

  // Update sessionStorage whenever assistanceMode changes
  useEffect(() => {
    sessionStorage.setItem("assistanceMode", assistanceMode);
  }, [assistanceMode]);

  return {
    assistanceMode,
    setAssistanceMode,
    assistanceOptions,
  };
};
